import React, { useState } from "react";
import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bookingId = location.state?.bookingId;
  const [showGuidanceModal, setShowGuidanceModal] = useState(Boolean(bookingId));

  const markGuidanceSeen = () => {
    if (bookingId) {
      localStorage.setItem(`postPaymentGuidanceSeen_${bookingId}`, "1");
    }
  };

  const handleCloseGuidanceModal = () => {
    markGuidanceSeen();
    setShowGuidanceModal(false);
  };

  const handleGoToBooking = () => {
    markGuidanceSeen();
    setShowGuidanceModal(false);
    if (bookingId) {
      navigate(`/dashboard/event/${bookingId}`);
    }
  };

  return (
    <>
      {bookingId && (
        <Modal
          show={showGuidanceModal}
          onHide={handleCloseGuidanceModal}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Your booking is confirmed!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-0">
              Next you&apos;ll need to forward passenger liability waivers to
              any other passengers. The trip cannot start until all passengers
              have completed their waivers.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleGoToBooking}>
              Go fill out waivers
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <Container className="mt-5 mb-5">
        <Row className="justify-content-center">
          <Col md={6}>
            <Card>
              <Card.Body>
                <Card.Title>Thank You!</Card.Title>
                <Card.Text>
                  {bookingId ? (
                    <>
                      Your payment was successful. Head to your{" "}
                      <Link to={`/dashboard/event/${bookingId}`}>
                        booking
                      </Link>{" "}
                      to fill out waivers for all passengers before trip day.
                    </>
                  ) : (
                    <>
                      Your payment was successful. Visit your{" "}
                      <Link to="/dashboard/bookings">dashboard</Link> to review
                      your bookings.
                    </>
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ThankYou;
